import { PaymentTermsActions, PaymentTermsActionTypes } from './payment-terms.actions';

/**
 * Payment terms State
 * @export
 * @interface IPaymentTermsState
 *
 */
export interface IPaymentTermsState {
  loading?: boolean;
  loaded?: boolean;
  paymentTerms: any[];
}

export const initialState: IPaymentTermsState = {
  loading: false,
  loaded: false,
  paymentTerms: [],
};

export function paymentTermsReducer(state = initialState, { payload, type }: PaymentTermsActions): IPaymentTermsState {
  switch (type) {
    case PaymentTermsActionTypes.LOAD_PAYMENT_TERMS_VALUES: {
      return {
        ...state,
        loading: true,
        loaded: false,
      } as IPaymentTermsState;
    }
    case PaymentTermsActionTypes.LOAD_PAYMENT_TERMS_VALUES_SUCCESS: {
      return {
        ...state,
        loaded: true,
        loading: false,
        paymentTerms: payload,
      } as IPaymentTermsState;
    }
    case PaymentTermsActionTypes.LOAD_PAYMENT_TERMS_VALUES_ERROR: {
      return {
        loaded: true,
        loading: false,
        paymentTerms: [],
      } as IPaymentTermsState;
    }
    default: {
      return state;
    }
  }
}
